<script setup>
import { dateUtil } from '@functions/dateUtil';
import ReturnGoods from '@parts/ReturnGoods.vue';

const props = defineProps({
    returnItems: {
        type: Array
        , default: () => []
    }
    , goodsTypes: {
        type: Array
        , default: () => []
    }
});

const emit = defineEmits(['selectReturnItem'])

const selectReturnItem = (item) => {
    const modal = document.getElementById('returnItemsChoiceAppModal');
    const bsModal = bootstrap.Modal.getInstance(modal);

    bsModal?.hide();
    emit('selectReturnItem', item);
}

</script>
<template>
    <div class="modal com_modal2 app1 sp1" id="returnItemsChoiceAppModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    <h3 class="com_fs18 com_strong1 com_center1 com_mgb15 com_lh1">
                        商品を選択してください
                    </h3>
                </div>
                <div class="modal-body">
                    <ReturnGoods
                        v-for="(returnItem, index) in returnItems"
                        :key="returnItem.salesDetailsLotId"
                        screen-id="ReturnItemsChoiceModal"
                        :goods="returnItem"
                        :index="index"
                        :goods-types="goodsTypes"
                        @select-drug="selectReturnItem"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
